import moment from 'moment';
import { Button } from 'components';
import { DownloadOutlined } from '@ant-design/icons';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

export const getCompanyDocumentViewSections = (t, item, { onDownloadFile } = {}) => {
  if (!item?.id) {
    return [];
  }

  const fileValue =
    item.file && onDownloadFile ? (
      <Button
        type='primary-white'
        icon={<DownloadOutlined />}
        onClick={() => onDownloadFile(item.file, item.file_name)}
      >
        {t('Scarica file')}
      </Button>
    ) : (
      '—'
    );

  return [
    {
      title: t('Info'),
      fields: [
        {
          text: t('Village'),
          value: display(
            item['shopping_centers.title'] || item.company?.shopping_center?.title,
          ),
        },
        {
          text: t('Catena'),
          value: display(item['chains.title'] || item.company?.chain?.title),
        },
        {
          text: t('Insegna'),
          value: display(item['companies.title'] || item.company?.title),
        },
        {
          text: t('Categorie'),
          value: display(
            item['company_document_categories.title'] || item.category?.title,
          ),
        },
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Data pubblicazione'),
          value: displayDate(item.publishing_date),
        },
      ],
    },
    {
      title: t('Allegato'),
      fields: [{ text: t('File'), value: fileValue }],
    },
  ];
};
